import React, { FC, useCallback } from 'react';
import { useIntl } from 'react-intl';
import Loading from '../../Loading';
import AdvancedFilter from '../AdvancedFilter';
import { TGroup } from '../types';
import { useAdvancedCurrentPeopleFilter } from './context';

type Props = {
  value: TGroup | undefined;
  onChange?: (value: TGroup | undefined) => void;
  onValidChange?: (message: string | null) => void;
  disabled?: boolean;
  required?: boolean;
  searchBarPlaceholder?: string;
};

const AdvancedCurrentPeopleFilter: FC<Props> = ({
  disabled = false,
  value,
  onChange,
  onValidChange,
  searchBarPlaceholder,
  required = false,
}) => {
  const { suggestions, selectedSuggestionConverter } =
    useAdvancedCurrentPeopleFilter();
  const { formatMessage } = useIntl();

  const handleOnChange = useCallback(
    (filters) => {
      onChange?.(filters);
    },
    [onChange]
  );

  if (!suggestions) {
    return (
      <Loading
        message={formatMessage({
          id: 'app.views.widgets.inputs.people_include_exclude_filter.message.loading_filters',
          defaultMessage: 'Loading filters...',
        })}
      />
    );
  }

  return (
    <AdvancedFilter
      required={required}
      disabled={disabled}
      suggestions={suggestions}
      suggestionForConditionConverter={selectedSuggestionConverter}
      value={value}
      onChange={handleOnChange}
      onValidChange={onValidChange}
      searchBarPlaceholder={searchBarPlaceholder}
    />
  );
};

export default React.memo(AdvancedCurrentPeopleFilter);
